<script>
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';
import PaginationControl from '../PaginationControl/PaginationControl.vue';

export default {
    components: {
        DropdownMenu,
        PaginationControl
    },
    props: {
        contractListMaxPages: {
            type: Number,
            default: null,
        },
        contractListPage: {
            type: Number,
            default: 1,
        },
        show: {
            type: Boolean,
            default: false,
        },
        showList: {
            type: Array,
            default: null,
        },
        years: {
            type: Array,
            default: null,
        },
        year: {
            type: String,
            default: null
        },
        limits: {
            type: Array,
            default: null,
        },
        limit: {
            type: String,
            default: null
        },
        filters: {
            type: Array,
            default: null,
        },
        filter: {
            type: String,
            default: null
        },
        search: {
            type: String,
            default: null
        }
    },
}
</script>
<template>
    <div class="contract-management-list-filters">
        <div class="contract-management-list-filters__option">
            <div class="contract-management-list-filters__pagination">
                <pagination-control :current-page="page"
                                    :max-pages="contractListMaxPages"
                                    @prev="$emit('pageDecrement')"
                                    @next="$emit('pageIncrement')"/>
            </div>
        </div>
        <div class="contract-management-list-filters__option">
            <dropdown-menu
                :label="$t('contractManagement.list.show.label')"
                :value="show"
                :items="showList"
                :searchable="false"
                :translation-prefix="'contractManagement.list.show'"
                @input="$emit('setShow', $event)"/>
        </div>
        <div class="contract-management-list-filters__option">
            <dropdown-menu
                :label="$t('contractManagement.list.year')"
                :value="year"
                :items="years"
                :searchable="false"
                @input="$emit('setYear', $event)"/>
        </div>
        <div class="contract-management-list-filters__option">
            <dropdown-menu
                :label="$t('contractManagement.list.perPage')"
                :value="limit"
                :items="limits"
                :searchable="false"
                @input="$emit('setLimit', $event)"/>
        </div>
        <div class="contract-management-list-filters__option">
            <dropdown-menu
                :label="$t('contractManagement.list.display.label')"
                :value="filter"
                :items="filters"
                :enable-deselect="true"
                :undefined-value="$t('contractManagement.list.display.all')"
                :translation-prefix="'contractManagement.list.status'"
                @input="$emit('setFilter', $event)"/>
        </div>
        <div class="contract-management-list-filters__option">
            <input :value="search"
                   :placeholder="$t('booking.filterText')"
                   type="text"
                   class="contract-management-list-filters__search-input"
                   @input="$emit('search', $event.target.value)">
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementListFilters/ContractManagementListFilters.vue